'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function CLFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-y5rgy737s", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-y5rgy737s)" }, /* @__PURE__ */ React.createElement("path", { fill: "#3d58db", d: "M0 0h14v14H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#f7fcff", d: "M14-2h18v16H14z" }), /* @__PURE__ */ React.createElement("path", { fill: "#e31d1c", d: "M0 14h32v10H0z" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#f7fcff",
        d: "M7.014 9.783l-3.803 2.272L5.088 8.19 1.764 5.68 5.6 5.639 7.05 2.21l.93 3.43 3.632.017L8.851 8.11l1.434 3.944z"
      }
    )))
  );
}

export { CLFlag };
//# sourceMappingURL=CL.mjs.map
